import { c as _c } from "react/compiler-runtime";
import { Alert, AlertBody, Heading, TextPassage } from '@petsmart-ui/sparky';
import { useEffect } from 'react';
import { trackBannerAlert } from '@libs/analytics';
const LinkedAutoshipAlert = t0 => {
  const $ = _c(4);
  const {
    isFraudValidationNeeded
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Heading tagName="h2" size="body-bold">Address linked to Autoship</Heading>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = isFraudValidationNeeded ? "Changes here won\u2019t affect your Autoship orders" : "Changing this address will update all associated Autoship orders";
  let t4;
  if ($[2] !== t3) {
    t4 = <Alert variant="warning" iconName="exclamation-outline"><AlertBody>{t2}<TextPassage capLinelength={false}>{t3}</TextPassage></AlertBody></Alert>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  return t4;
};
export default LinkedAutoshipAlert;
function _temp() {
  trackBannerAlert("my account | addresses", "address linked to autoship");
}